const urls = {

    //TODO: Persist these urls to env files and load from there
    //apiBaseUrl: 'https://rmbackend.azurewebsites.net/api/',
   //apiBaseUrl: 'https://alfaenergyriskmanagement.azurewebsites.net/api/',//azure
    apiBaseUrl: process.env.NODE_ENV !== 'production' ?  'http://localhost:44327/api/': '#{environment_api_url}#',//changed with replace tokens on release pipeline
    //ssoBaseUrl: process.env.NODE_ENV !== 'production' ? 'https://ssodev.alfaenergygroup.org/' : '#{environment_sso_url}#',//changed with replace tokens on release pipeline
    resolveBaseUrl: process.env.NODE_ENV !== 'production' ? 'https://cpdemo.alfaenergygroup.org' : '#{environment_resolve_url}#',//changed with replace tokens on release pipeline
    helpDeskUrl: process.env.NODE_ENV !== 'production' ? 'https://ithelpdesk.alfaenergygroup.org' : '#{environment_helpDesk_url}#',//changed with replace tokens on release pipeline
    tocBaseUrl: process.env.NODE_ENV !== 'production' ? 'https://tocdev.alfaenergygroup.org' : '#{environment_toc_url}#',//changed with replace tokens on release pipeline
    assureBaseUrl: process.env.NODE_ENV !== 'production' ? 'https://assuredev.alfaenergygroup.org' : '#{environment_assure_url}#',//changed with replace tokens on release pipeline
    azureADClientId: process.env.NODE_ENV !== 'production' ? 'f28e0708-0adc-4b59-8fa5-d6e6bcf8227b' : '#{environment_AdClientId}#',
    azureADTenantId: process.env.NODE_ENV !== 'production' ? '86d8d78a-accb-4fda-8b30-7db7bd370d8b' : '#{environment_AdTenantId}#',


 getReturnUrl: () => {
        //let fragment;
        //if (window.location.pathname === "/ssolanding")
        //    fragment = "/home";
        //else
        //    fragment = window.location.pathname;

        //var path = `${fragment}${window.location.search}`;
        //var retUrl = `${window.location.protocol}//${window.location.host}/ssolanding?url=${encodeURIComponent(path)}`;
        //var url = `${urls.ssoBaseUrl}?redirect=${encodeURIComponent(retUrl)}`;
        //return url;
        // AZURE AD
        var retUrl = `${window.location.protocol}//${window.location.host}/ssolanding`;
        return retUrl;
    },
    //getResetUrl: (email, username) => {
    //    var path = `${window.location.pathname}${window.location.search}`;
    //    var retUrl = `${window.location.protocol}//${window.location.host}/ssolanding?url=${encodeURIComponent(path)}`;
    //    var url = `${urls.ssoBaseUrl}Home/ChangePassword?email=${email}&username=${username}&returnUrl=${encodeURIComponent(retUrl)}`;
    //    return url;
    //}
}
export default urls;
